import { useEffect } from 'react';
import Platform from 'platform';

const isBrowser = Platform.getName() === 'Browser';

export default (callback) => {
  useEffect(() => {
    const onKeydown = async ({ keyCode }) => {
      if (keyCode !== 86 || !isBrowser) return;
      const text = await navigator.clipboard.readText();
      callback && callback(text);
    };
    document.addEventListener('keydown', onKeydown, true);
    return () => document.removeEventListener('keydown', onKeydown, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
